import type { ReactNode } from 'react';

import type { GiftPassDetail } from '../../api/gift-passes';

import { GiftPassActivityCard } from './GiftPassActivityCard';
import { GiftPassSendHistoryCard } from './GiftPassSendHistoryCard';
import { GiftPassSummaryCard } from './GiftPassSummaryCard';

export interface GiftPassDetailBodyProps {
  pass: GiftPassDetail;
  actions?: ReactNode;
}

export function GiftPassDetailBody({ pass, actions }: GiftPassDetailBodyProps) {
  return (
    <div className="gp-detail-grid">
      <div className="gp-detail-column">
        <GiftPassSummaryCard pass={pass} actions={actions} />
      </div>
      <div className="gp-detail-column">
        <GiftPassActivityCard pass={pass} />
        <GiftPassSendHistoryCard sends={pass.sends} />
      </div>
    </div>
  );
}
